import './styles.scss';

import moment from 'moment';

export default {
    name: 'AnnotationsPage',

    data() {
        return {
            poll: false
        }
    },

    computed: {
        list() {
            return this.$store.getters.sharedAnnotations;
        },

        desktop() {
            return this.$store.state.desktop;
        }
    },

    watch: {
        list(newValue) {
            this.$store.commit('setMenuItems', this.list);
        }
    },

    methods: {
        formatDate(data) {
            return moment(data).fromNow();
        },

        async setup() {
            this.$store.commit('setActiveMenu', true);
        }
    },

    mounted() {
        this.$store.commit('setActiveMenu', false);
        this.setup();
    },

    created() {

        this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Annotations Shared with You', slug: 'annotations' });
        
        this.$store.dispatch('getStampsList');
        this.$store.dispatch('fetchDocuments');
        this.$store.dispatch('getSharedAnnotations');

        this.poll = window.setInterval(() => { console.info('Refreshing annotations...'); this.$store.dispatch('getSharedAnnotations'); }, 10000);

        this.$store.commit('resetMessage');
        this.$store.commit('resetSearch');
    },

    beforeDestroy() {
        console.info("Unmounting annotations page...");
        window.clearInterval(this.poll);
    }

};